/* CPPerformance homepage conversion mounts — conversion upgrade */
(function () {
  let finderNode = null;
  let finderSourceHolder = null;

  function mountFinder() {
    const main = document.querySelector("main[data-template='index']");
    if (!main) return;

    const hero = main.querySelector('.shopify-section:first-child .hero__container');
    const candidate = main.querySelector('[data-vehicle-finder]');
    if (!hero || !candidate) return;

    finderNode = candidate;
    if (!finderSourceHolder || !document.documentElement.contains(finderSourceHolder)) {
      finderSourceHolder = candidate.closest('.shopify-section');
    }

    if (!hero.contains(candidate)) {
      candidate.classList.add('vehicle-finder--hero');
      hero.appendChild(candidate);
    }

    if (finderSourceHolder && finderSourceHolder !== hero.closest('.shopify-section')) {
      finderSourceHolder.classList.add('cp-finder-source-empty');
      finderSourceHolder.hidden = true;
      finderSourceHolder.setAttribute('aria-hidden', 'true');
    }
    document.documentElement.classList.add('cp-hero-finder-mounted');
  }

  function restoreBeforeUnload(event) {
    if (
      finderNode &&
      finderSourceHolder &&
      event.target &&
      event.target.contains(finderNode) &&
      document.documentElement.contains(finderSourceHolder)
    ) {
      finderSourceHolder.hidden = false;
      finderSourceHolder.removeAttribute('aria-hidden');
      finderSourceHolder.classList.remove('cp-finder-source-empty');
      finderSourceHolder.appendChild(finderNode);
      document.documentElement.classList.remove('cp-hero-finder-mounted');
    }
  }

  const lastSearchKey = 'cpLastSearchV1';

  function usableSearchTerm(value) {
    const term = String(value || '').trim();
    return term && term.toLowerCase().indexOf('cpfitment') === -1;
  }

  function rememberSearches() {
    let saved = '';
    try { saved = window.localStorage.getItem(lastSearchKey) || ''; } catch (e) {}

    const params = new URLSearchParams(window.location.search);
    const urlTerm = params.get('q') || '';
    if (window.location.pathname.indexOf('/search') === 0 && usableSearchTerm(urlTerm) && !params.get('vehicle_ids')) {
      saved = urlTerm.trim();
      try { window.localStorage.setItem(lastSearchKey, saved); } catch (e) {}
    }

    document.querySelectorAll('form[action*="/search"]').forEach(function (form) {
      const input = form.querySelector('input[name="q"]');
      if (!input) return;

      if (!input.value.trim() && saved) {
        input.value = saved;
      }

      if (form.dataset.cpSearchMemory === 'true') return;
      form.dataset.cpSearchMemory = 'true';

      form.addEventListener('submit', function () {
        const value = input.value.trim();
        if (!usableSearchTerm(value)) return;
        try { window.localStorage.setItem(lastSearchKey, value); } catch (e) {}
      });
    });
  }

  function mountAll() {
    mountFinder();
    rememberSearches();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:unload', restoreBeforeUnload);
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(mountAll, 0);
  });
  window.addEventListener('pageshow', function () {
    window.setTimeout(mountAll, 0);
  });
})();
